import { AxiosInstance } from "axios";

import { BookedMeetingCalendarEventI } from "shared/lib/interfaces/meeting-acceptance";

const getBaseURL = (campaignId: string, accountId: string) =>
  `/v1/campaign/${campaignId}/account/${accountId}/calendar_events`;

export interface SyncMeetingAcceptanceStatusForActivityLogResponseI {
  event: BookedMeetingCalendarEventI | null;
}

export const BookedMeetingCalendarEventsEndpoints = (
  client: AxiosInstance
) => ({
  getForAccount: (
    campaignId: string,
    accountId: string,
    shouldSync: boolean = false
  ) => {
    let baseURL = getBaseURL(campaignId, accountId);

    if (shouldSync) {
      baseURL += "?should_sync=true";
    }

    return client.get<SyncMeetingAcceptanceStatusForActivityLogResponseI>(
      baseURL
    );
  },
});
